// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 오라클 성능 분석 — SQL 단위 분석과 인스턴스 단위 분석을 한 창에 담는 컨테이너.
   본문은 각 원본 모달(embedded)이 자기 CSS 로 그리므로, 여기는 껍데기만 정의한다. */

.oraperf-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.oraperf-modal {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  width: 94%;
  max-width: 1400px;
  /* 실시간 성능 탭이 스크롤 없이 두 차트를 담을 수 있는 높이 —
     차트를 낮추는 대신 창을 키운다(그래프 높이는 읽기의 정확도에 직결된다). */
  height: calc(94vh / var(--app-zoom, 1));
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.oraperf-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}
.oraperf-header h2 { margin: 0; font-size: 14px; font-weight: 600; color: #333; }
.oraperf-close { background: none; border: none; cursor: pointer; color: #999; padding: 4px; display: flex; align-items: center; }
.oraperf-close:hover { color: #333; }

.oraperf-tabs {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}
.oraperf-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  border: none;
  background: none;
  color: #6b7280;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: color 150ms ease, border-color 150ms ease;
}
.oraperf-tab:hover { color: #374151; }
.oraperf-tab.active { color: #3b82f6; border-bottom-color: #3b82f6; }
@media (prefers-reduced-motion: reduce) { .oraperf-tab { transition: none; } }

/* SQL 단위 탭과 인스턴스 단위 탭의 경계 */
.oraperf-tab-divider {
  width: 1px;
  height: 16px;
  margin: 0 8px;
  background: #d1d5db;
  flex-shrink: 0;
}

.oraperf-tabs-spacer { flex: 1 1; }

.oraperf-select {
  min-width: 160px;
  padding: 5px 8px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #fff;
  color: #374151;
  font-size: 12px;
}

/* 본문 — 내부 모달이 자기 스크롤/패딩을 가지므로 여기서는 흐르게만 둔다 */
.oraperf-body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.oraperf-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px 16px;
  border-top: 1px solid #e0e0e0;
  background: #f8f9fa;
  flex-shrink: 0;
}
.oraperf-btn {
  padding: 6px 14px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #fff;
  color: #374151;
  font-size: 12px;
  cursor: pointer;
}
.oraperf-btn:hover { background: #f3f4f6; }

/* 임베드된 본문이 자기 창인 줄 알고 붙이던 여백/높이를 컨테이너 기준으로 되돌린다 */
.oraperf-body .analysis-modal-body,
.oraperf-body .dbmsperf-body {
  flex: 1 1;
  min-height: 0;
}

.dbmsperf-embedded-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 6px 20px 0;
  flex-shrink: 0;
}

[data-theme="dark"] .oraperf-modal { background: var(--color-bg-tertiary); color: var(--color-text); }
[data-theme="dark"] .oraperf-header,
[data-theme="dark"] .oraperf-tabs,
[data-theme="dark"] .oraperf-footer { background: var(--color-bg-secondary); border-color: var(--color-border); }
[data-theme="dark"] .oraperf-header h2 { color: var(--color-text); }
[data-theme="dark"] .oraperf-close { color: var(--color-text-muted); }
[data-theme="dark"] .oraperf-close:hover { color: var(--color-text); }
[data-theme="dark"] .oraperf-tab { color: var(--color-text-muted); }
[data-theme="dark"] .oraperf-tab:hover { color: var(--color-text); }
[data-theme="dark"] .oraperf-tab-divider { background: var(--color-border); }
[data-theme="dark"] .oraperf-select,
[data-theme="dark"] .oraperf-btn { background: var(--color-bg-tertiary); color: var(--color-text); border-color: var(--color-border); }
`, "",{"version":3,"sources":["webpack://./src/components/monitoring/OraclePerfAnalysisModal.css"],"names":[],"mappings":"AAAA;yDACyD;;AAEzD;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,UAAU;EACV,iBAAiB;EACjB;gDAC8C;EAC9C,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;AACA,qBAAqB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;AAChF,iBAAiB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACjI,uBAAuB,WAAW,EAAE;;AAEpC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,qDAAqD;AACvD;AACA,qBAAqB,cAAc,EAAE;AACrC,sBAAsB,cAAc,EAAE,4BAA4B,EAAE;AACpE,0CAA0C,eAAe,gBAAgB,EAAE,EAAE;;AAE7E,4BAA4B;AAC5B;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB,SAAO,EAAE;;AAEhC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA,qBAAqB,mBAAmB,EAAE;;AAE1C,kDAAkD;AAClD;;EAEE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qCAAqC,oCAAoC,EAAE,wBAAwB,EAAE;AACrG;;sCAEsC,qCAAqC,EAAE,iCAAiC,EAAE;AAChH,yCAAyC,wBAAwB,EAAE;AACnE,qCAAqC,8BAA8B,EAAE;AACrE,2CAA2C,wBAAwB,EAAE;AACrE,mCAAmC,8BAA8B,EAAE;AACnE,yCAAyC,wBAAwB,EAAE;AACnE,2CAA2C,+BAA+B,EAAE;AAC5E;mCACmC,oCAAoC,EAAE,wBAAwB,EAAE,iCAAiC,EAAE","sourcesContent":["/* 오라클 성능 분석 — SQL 단위 분석과 인스턴스 단위 분석을 한 창에 담는 컨테이너.\r\n   본문은 각 원본 모달(embedded)이 자기 CSS 로 그리므로, 여기는 껍데기만 정의한다. */\r\n\r\n.oraperf-overlay {\r\n  position: fixed;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1001;\r\n}\r\n\r\n.oraperf-modal {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 32px rgba(0,0,0,0.2);\r\n  width: 94%;\r\n  max-width: 1400px;\r\n  /* 실시간 성능 탭이 스크롤 없이 두 차트를 담을 수 있는 높이 —\r\n     차트를 낮추는 대신 창을 키운다(그래프 높이는 읽기의 정확도에 직결된다). */\r\n  height: calc(94vh / var(--app-zoom, 1));\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.oraperf-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 10px 16px;\r\n  background: #f8f9fa;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  flex-shrink: 0;\r\n}\r\n.oraperf-header h2 { margin: 0; font-size: 14px; font-weight: 600; color: #333; }\r\n.oraperf-close { background: none; border: none; cursor: pointer; color: #999; padding: 4px; display: flex; align-items: center; }\r\n.oraperf-close:hover { color: #333; }\r\n\r\n.oraperf-tabs {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: 0 16px;\r\n  background: #f8f9fa;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  flex-shrink: 0;\r\n}\r\n.oraperf-tab {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 10px 12px;\r\n  border: none;\r\n  background: none;\r\n  color: #6b7280;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  border-bottom: 2px solid transparent;\r\n  white-space: nowrap;\r\n  transition: color 150ms ease, border-color 150ms ease;\r\n}\r\n.oraperf-tab:hover { color: #374151; }\r\n.oraperf-tab.active { color: #3b82f6; border-bottom-color: #3b82f6; }\r\n@media (prefers-reduced-motion: reduce) { .oraperf-tab { transition: none; } }\r\n\r\n/* SQL 단위 탭과 인스턴스 단위 탭의 경계 */\r\n.oraperf-tab-divider {\r\n  width: 1px;\r\n  height: 16px;\r\n  margin: 0 8px;\r\n  background: #d1d5db;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.oraperf-tabs-spacer { flex: 1; }\r\n\r\n.oraperf-select {\r\n  min-width: 160px;\r\n  padding: 5px 8px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  color: #374151;\r\n  font-size: 12px;\r\n}\r\n\r\n/* 본문 — 내부 모달이 자기 스크롤/패딩을 가지므로 여기서는 흐르게만 둔다 */\r\n.oraperf-body {\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.oraperf-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding: 10px 16px;\r\n  border-top: 1px solid #e0e0e0;\r\n  background: #f8f9fa;\r\n  flex-shrink: 0;\r\n}\r\n.oraperf-btn {\r\n  padding: 6px 14px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 4px;\r\n  background: #fff;\r\n  color: #374151;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n}\r\n.oraperf-btn:hover { background: #f3f4f6; }\r\n\r\n/* 임베드된 본문이 자기 창인 줄 알고 붙이던 여백/높이를 컨테이너 기준으로 되돌린다 */\r\n.oraperf-body .analysis-modal-body,\r\n.oraperf-body .dbmsperf-body {\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.dbmsperf-embedded-bar {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  padding: 6px 20px 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n[data-theme=\"dark\"] .oraperf-modal { background: var(--color-bg-tertiary); color: var(--color-text); }\r\n[data-theme=\"dark\"] .oraperf-header,\r\n[data-theme=\"dark\"] .oraperf-tabs,\r\n[data-theme=\"dark\"] .oraperf-footer { background: var(--color-bg-secondary); border-color: var(--color-border); }\r\n[data-theme=\"dark\"] .oraperf-header h2 { color: var(--color-text); }\r\n[data-theme=\"dark\"] .oraperf-close { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .oraperf-close:hover { color: var(--color-text); }\r\n[data-theme=\"dark\"] .oraperf-tab { color: var(--color-text-muted); }\r\n[data-theme=\"dark\"] .oraperf-tab:hover { color: var(--color-text); }\r\n[data-theme=\"dark\"] .oraperf-tab-divider { background: var(--color-border); }\r\n[data-theme=\"dark\"] .oraperf-select,\r\n[data-theme=\"dark\"] .oraperf-btn { background: var(--color-bg-tertiary); color: var(--color-text); border-color: var(--color-border); }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
